<template>
    <h1 class="heading-2">Consentimento</h1>

    <div class="user-consent-form">
        <div class="consent-title-wrapper">
            <h5>Contrato de arrendamento</h5>
            <div class="caption-lg">
                *Para avançar é necessário ler os termos abaixo
            </div>
        </div>
        <div
            class="contract"
            aria-describedby="Professional Contract Terms & Conditions"
            ref="contractcontainer"
            @scrollend="contractScrollEnd()"
        >
            <div class="contract-box" id="contract-box" ref="contractbox"></div>
        </div>

        <div class="consent-footer-wrapper">
            <div class="form-check">
                <input
                    @click="userAgreement($event)"
                    class="form-check-input"
                    type="checkbox"
                    id="user_agreement"
                    :checked="formData.agreement"
                    :disabled="activecheckbox"
                />
                <label class="form-check-label caption-lg" for="user_agreement">
                    Confirmo que li e aceito as condições presentes neste
                    contrato
                </label>
            </div>

            <button
                @click="getUserAgreement()"
                type="button"
                class="btn btn-primary w-100 btn-filled-blue"
                :disabled="disabled"
            >
                <p class="button-body">Avançar</p>
            </button>
        </div>
    </div>
</template>
<script>
import htmlElements from "../../../htmlElements.js";

//Set Use Strict
("use strict");

export default {
    emits: ["form-data"],
    name: "Contract",
    props: {
        contracttext: {
            type: String,
            required: true,
        },
        onboardsequence: {
            type: Function,
            required: false,
        },
        professionaldata: {
            type: Object,
            required: false,
        },
    },
    data: () => {
        return {
            disabled: true,
            formData: {
                agreement: false,
                contract: "",
            },
            contractScroll: "",
            professionalContractData: {
                name: "",
                address: "",
                nif: "",
            },
            activecheckbox: true,
        };
    },
    created() {
        //Get Professional Data
        //let professionalData = sessionStorage.getItem('professionalData');
        //this.professionalContractData = JSON.parse(professionalData);
    },
    mounted() {
        //Set Contract Text
        this.$refs.contractbox.innerHTML = this.contracttext;

        //Check When exist Professional Data
        if (this.professionaldata !== undefined) {
            //Create a new element and put in the second position
            let name = atob(this.professionaldata.name);
            let address = atob(this.professionaldata.address);
            let nif = atob(this.professionaldata.nif);

            //Get Contract Box Childrens
            let childrens = [...this.$refs.contractbox.children];

            let newElement = htmlElements.createElement(
                "p",
                {
                    class: "contract-editable-paragraph",
                    contenteditable: true,
                },
                `Nome: ${name}, 
            Morada: ${address},
            Nif: ${nif}
            `
            );

            //Set Professional Info
            this.$refs.contractbox.insertBefore(newElement, childrens[0]);
        }
    },
    methods: {
        contractScrollEnd() {
            this.activecheckbox = false;

            /*  console.log(element.target.clientHeight);
            console.log(this.$refs.contractbox.getBoundingClientRect());
            console.log(element.target.scrollHeight);
            console.log(element.target.offsetHeight); */
        },
        userAgreement(element) {
            this.formData.agreement = element.currentTarget.checked;

            //Enabled Button
            this.disabled = this.formData.agreement ? false : true;
        },
        getUserAgreement() {
            //Get Contract Data
            this.formData.contract = this.$refs.contractbox.innerHTML;

            //Get User Agreement
            this.$emit("form-data", this.formData);

            //Enable Sequence
            if (this.onboardsequence !== undefined) {
                this.$props.onboardsequence("categoria");
            }
        },
        enabledCheckBox() {
            //Client Height
            let clientHeight = this.$el.clientHeight;

            //Scroll Height
            let scrollHeight = this.$el.scrollHeight;

            //Check Scroll
            console.log(clientHeight, scrollHeight);
            console.log(this.$el);
        },
    },
    computed: {
        formDataComputed() {
            return this.formData;
        },
        disabledComputed() {
            return this.disabled;
        },
        contractScrollComputed() {
            return this.contractScroll;
        },
        professionalDataComputed() {
            return this.professionaldata;
        },
        activeCheckboxComputed() {
            return this.activecheckbox;
        },
    },
    watch: {
        formDataComputed() {},
        disabledComputed() {},
        contractScrollComputed() {},
        professionalDataComputed() {},
        activeCheckboxComputed() {},
    },
    unmounted() {
        //Set Professional Data
        this.professionalContractData = {};

        //Remove Session Storage
        //sessionStorage.removeItem('professionalData');
    },
};
</script>
